export function isMobile() {
    return window.innerWidth <= 767;
}
